import { type BoardTasksState } from './tasksSlice';
import { type BoardTaskStatus } from '../../../../common/types/task';

const createStatusMap = (): Record<BoardTaskStatus, number[]> => ({
  NOT_STARTED: [],
  IN_PROGRESS: [],
  WAITING: [],
  DONE: [],
  ARCHIVED: [],
});

const createCursorMap = (): Record<BoardTaskStatus, number | null> => ({
  NOT_STARTED: null,
  IN_PROGRESS: null,
  WAITING: null,
  DONE: null,
  ARCHIVED: null,
});

const createIsLoadedByStatus = (): Record<BoardTaskStatus, boolean> => ({
  NOT_STARTED: false,
  IN_PROGRESS: false,
  WAITING: false,
  DONE: false,
  ARCHIVED: false,
});

const createCountByStatus = (): Record<BoardTaskStatus, number> => ({
  NOT_STARTED: 0,
  IN_PROGRESS: 0,
  WAITING: 0,
  DONE: 0,
  ARCHIVED: 0,
});

export const initialState: BoardTasksState = {
  byId: {},
  idsByStatus: createStatusMap(),
  cursorByStatus: createCursorMap(),
  isFullyLoadedByStatus: createIsLoadedByStatus(),
  countByStatus: createCountByStatus(),
  isWorkTime: false,
};
